// The consulting sales-tax policies a seller may publish in immutable terms,
// what each one allows, and its plain words. Pure: no imports. Read by the
// World (lib/consultingTax.js, the one assessment) and by the Desk
// (APPS/cleo-code/apps/web/src/neucleos/consultingClient.ts) so a buyer's
// form and an approval card say exactly what checkout enforces.
//
// 2 Oct 2026, researched: professional advice/custom business applications
// received in California or Ohio carry no sales tax; others refuse.
export const CA_OH_TAX_POLICY = "us-ca-oh-professional-services-2026-10-02";
// 8 Oct 2026, the principal's decision on his accountant's confirmation: sell
// to buyers in every US state and DC at no sales tax. US territories keep
// their own tax regimes (Puerto Rico's IVU reaches services), so their buyers
// are asked to contact the consultant, and buyers outside the United States
// are refused, before any payment exists.
export const US_ALL_STATES_TAX_POLICY = "us-all-states-no-sales-tax-2026-10-08";
export const CONSULTING_TAX_POLICIES = Object.freeze([CA_OH_TAX_POLICY, US_ALL_STATES_TAX_POLICY]);

export const US_STATE_NAMES = Object.freeze({
  AL: "Alabama", AK: "Alaska", AZ: "Arizona", AR: "Arkansas", CA: "California", CO: "Colorado",
  CT: "Connecticut", DE: "Delaware", DC: "District of Columbia", FL: "Florida", GA: "Georgia",
  HI: "Hawaii", ID: "Idaho", IL: "Illinois", IN: "Indiana", IA: "Iowa", KS: "Kansas", KY: "Kentucky",
  LA: "Louisiana", ME: "Maine", MD: "Maryland", MA: "Massachusetts", MI: "Michigan", MN: "Minnesota",
  MS: "Mississippi", MO: "Missouri", MT: "Montana", NE: "Nebraska", NV: "Nevada", NH: "New Hampshire",
  NJ: "New Jersey", NM: "New Mexico", NY: "New York", NC: "North Carolina", ND: "North Dakota",
  OH: "Ohio", OK: "Oklahoma", OR: "Oregon", PA: "Pennsylvania", RI: "Rhode Island",
  SC: "South Carolina", SD: "South Dakota", TN: "Tennessee", TX: "Texas", UT: "Utah", VT: "Vermont",
  VA: "Virginia", WA: "Washington", WV: "West Virginia", WI: "Wisconsin", WY: "Wyoming",
});
export const US_STATES_AND_DC = Object.freeze(Object.keys(US_STATE_NAMES));
export const US_TERRITORIES = Object.freeze(["PR", "GU", "VI", "AS", "MP", "UM"]);
// Military mail (Armed Forces Americas, Europe, Pacific) and the freely
// associated states use US postal codes but are not states: each needs its own
// tax check, so the buyer is asked to contact the consultant.
export const US_MILITARY_MAIL = Object.freeze(["AA", "AE", "AP"]);
export const FREELY_ASSOCIATED_STATES = Object.freeze(["FM", "MH", "PW"]);

/** The US regions (two-letter codes) each policy sells to at no sales tax. */
export const CONSULTING_TAX_POLICY_REGIONS = Object.freeze({
  [CA_OH_TAX_POLICY]: Object.freeze(["CA", "OH"]),
  [US_ALL_STATES_TAX_POLICY]: US_STATES_AND_DC,
});
/** Each policy as the buyer reading the purchase form sees it. */
export const CONSULTING_TAX_POLICY_WORDS = Object.freeze({
  [CA_OH_TAX_POLICY]: "No sales tax; buyers in California or Ohio only",
  [US_ALL_STATES_TAX_POLICY]: "No sales tax; buyers in every US state",
});
/** Each policy as the seller approving it sees it on the card: who buys at no tax, and who does not. */
export const CONSULTING_TAX_POLICY_CARD_WORDS = Object.freeze({
  [CA_OH_TAX_POLICY]: "No sales tax; buyers in California or Ohio only; buyers anywhere else are asked to contact the consultant",
  [US_ALL_STATES_TAX_POLICY]: "No sales tax; buyers in every US state and DC; buyers in US territories, military mail (AA, AE, AP) or the freely associated states (FM, MH, PW) are asked to contact the consultant; buyers outside the US are refused",
});
